// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"pc_privacyPolicy__MFBrk","not-margin":"pc_not-margin__CUJg6","not-sort":"pc_not-sort__yu8Ap","privacyPolicyContent":"pc_privacyPolicyContent__a9kEr"};